import { CampagnePatrimoineSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const CampagnePatrimoineModel: SelectorModel = {
  name: 'campagnePatrimoines',
  getSelector: CampagnePatrimoineSelectors.selectAllCampagnePatrimoinesDictionary,
  isReady: CampagnePatrimoineSelectors.selectIsReadyCampagnePatrimoine
};
